<template>
  <section>
    <html2Pdf
      ref="vuepdf"
      @hasDownloaded="handleDowloaded"
      :fileName="`
                ${this.transactionDetails.txn_data.pin_umber}-${this.transactionDetails.txn_data.txn_date}`"
    >
      <v-card class="pa-2" style="position: relative">
        <div class="pos_abs text-center">
          <div>Re-print Copy</div>
        </div>
        <div class="pos_abs_2 text-center">
          <div>Re-print Copy</div>
        </div>
        <v-row class="ma-0 text-center p-3">
          <v-col cols="2" class="m-auto">
            <img
              src="../../assets/master_logo.png"
              alt="QQPay"
              style="max-height: 60px; max-width: 100px"
            />
          </v-col>
          <v-col cols="4" class="text-left ms-4">
            <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
            <p class="ma-0 pa-0">
              Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
              Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
            </p>
            <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
          </v-col>
          <v-col>
            <h4 class="mb-0">RECEIPT</h4>
            <p class="red--text ma-0 pa-0">Duplicate Copy</p>
          </v-col>
          <v-col>Customer Copy </v-col>
        </v-row>
        <v-row class="ma-0 px-3 justify-space-between">
          <p class="ma-0 pa-0">
            TRANSACTION NUMBER:<span class="font-weight-bold">
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.pin_umber
                  ? this.transactionDetails.txn_data &&
                    this.transactionDetails.txn_data.pin_umber
                  : ""
              }}</span
            >
          </p>
          <p
            class="ma-0 pa-0"
            v-if="this.transactionDetails.txn_data.receiver_cpay_pinnumber"
          >
            Cash Pickup Pin Number:<span class="font-weight-bold">{{
              this.transactionDetails.txn_data.receiver_cpay_pinnumber
            }}</span>
          </p>
          <p>
            Transaction Date: {{ this.transactionDetails.txn_data.txn_date }}
          </p>
        </v-row>
        <v-row class="border_color ma-3 pa-4">
          <v-col class="p-3 lh-2 main">
            <h6>REMITTER</h6>
            <v-divider class="ma-0"></v-divider>
            <div>
              <span class="w_200px">Name :</span>
              <b>{{
                senderInfo.middle_name
                  ? senderInfo.first_name +
                    " " +
                    senderInfo.middle_name +
                    " " +
                    senderInfo.last_name
                  : senderInfo.last_name
                  ? senderInfo.first_name + " " + senderInfo.last_name
                  : senderInfo.first_name
              }}</b>
            </div>
            <div>
              <span class="w_200px">Address :</span
              >{{ this.senderInfo.address ? this.senderInfo.address : "" }}
            </div>
            <div>
              <span class="w_200px">Customer Id :</span
              >{{ senderInfo.customer_id }}
            </div>
            <div>
              <span class="w_200px">Source of Fund:</span
              >{{
                senderInfo.source_of_funds && senderInfo.source_of_funds.value
                  ? senderInfo.source_of_funds.value
                  : ""
              }}
            </div>
            <div>
              <span class="w_200px">Purpose of Transaction:</span
              >{{
                transactionInfo.purpose_of_remittance &&
                transactionInfo.purpose_of_remittance.value
                  ? transactionInfo.purpose_of_remittance.value
                  : ""
              }}
            </div>
            <h6 class="mt-2">BENEFICIARY :</h6>
            <v-divider class="mt-0"></v-divider>
            <div>
              <span class="w_200px">Name :</span>
              <b v-if="!recieverInfo.full_name">{{
                recieverInfo.middle_name
                  ? recieverInfo.first_name +
                    " " +
                    recieverInfo.middle_name +
                    " " +
                    recieverInfo.last_name
                  : recieverInfo.last_name
                  ? recieverInfo.first_name + " " + recieverInfo.last_name
                  : recieverInfo.first_name
              }}</b>
              <b v-else>{{ recieverInfo.full_name }}</b>
            </div>
            <div>
              <span class="w_200px">Address :</span>
              {{ this.recieverInfo.address ? this.recieverInfo.address : "" }}
            </div>
            <div>
              <span class="w_200px">Telephone :</span>
              {{ this.recieverInfo.mobile ? this.recieverInfo.mobile : "" }}
            </div>
            <div>
              <span class="w_200px">Transaction Type :</span>
              <b>{{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.payment_mode
                  ? this.transactionDetails.txn_data.payment_mode
                  : ""
              }}</b>
            </div>
            <div>
              <span class="w_200px">Bank Name :</span>
              {{
                this.recieverInfo.location_name
                  ? this.recieverInfo.location_name
                  : ""
              }}
            </div>
            <div>
              <span class="w_200px">Account No :</span>
              {{
                this.recieverInfo.ac_number ? this.recieverInfo.ac_number : ""
              }}
            </div>
            <div>
              <span class="w_200px">THRU/Partner :</span
              ><span
                ><b>{{
                  this.transactionDetails.txn_data &&
                  this.transactionDetails.txn_data.payout_partner
                    ? this.transactionDetails.txn_data &&
                      this.transactionDetails.txn_data.payout_partner
                    : ""
                }}</b></span
              >
            </div>
          </v-col>
          <v-col class="bord-left">
            <v-simple-table>
              <tr>
                <td>Collected Amount</td>
                <td>
                  <span class="font-weight-bold">{{
                    transactionInfo.total_coll_amt
                      ? transactionInfo.total_coll_amt
                      : ""
                  }}</span>
                </td>
              </tr>
              <tr>
                <td class="">Service Charge</td>
                <td class="font-weight-bold">
                  {{
                    transactionInfo.service_charge
                      ? transactionInfo.service_charge
                      : ""
                  }}
                </td>
              </tr>

              <tr>
                <td>Transfer Amount</td>
                <td class="font-weight-bold">
                  {{
                    transactionInfo.transfer_amt
                      ? transactionInfo.transfer_amt
                      : ""
                  }}
                </td>
              </tr>
              <tr>
                <td>Exchange Rate</td>
                <td class="font-weight-bold">
                  1 {{ transactionInfo.coll_currency }} =
                  {{ transactionInfo.rate }}
                  {{ transactionInfo.pay_currency }}
                </td>
              </tr>
              <tr>
                <td>Payout Amount</td>
                <td class="font-weight-bold">
                  <span class="font-weight-bold text--primary">
                    {{
                      transactionInfo.payout_amt
                        ? transactionInfo.payout_amt
                        : ""
                    }}</span
                  >
                </td>
              </tr>
            </v-simple-table>
            <div class="px-1 mt-5">Processed By:</div>
            <v-divider class="pa-0 ma-1"></v-divider>
            <v-col
              ><div class="px-3">
                {{
                  transactionInfo.created_by ? transactionInfo.created_by : ""
                }}
              </div></v-col
            >
          </v-col>
        </v-row>
        <v-row class="ma-0 px-2 mb-3">
          <h4>REMINDERS TO OUR REMITTTERS/CLIENTS</h4>
          <div>
            1. Please inform of any change in your personal data submitted e.g
            Visa status/validity, name, address, contact number and other
            details pertaining to your remittance transaction by sending a mail,
            fax, SMS and submitting a front and back copy of the ID as proof of
            the change as required by Law.
          </div>
        </v-row>
        <v-row class="ma-0 text-center p-3 mt-5">
          <v-col cols="2" class="m-auto">
            <img
              src="../../assets/master_logo.png"
              alt="QQPay"
              style="max-height: 60px; max-width: 100px"
            />
          </v-col>
          <v-col cols="4" class="text-left ms-4">
            <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
            <p class="ma-0 pa-0">
              Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
              Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
            </p>
            <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
          </v-col>
          <v-col>
            <h4 class="mb-0">RECEIPT</h4>
            <p class="red--text ma-0 pa-0">Duplicate Copy</p>
          </v-col>
          <v-col>Office Copy </v-col>
        </v-row>
        <v-row class="ma-0 px-3 justify-space-between">
          <p class="ma-0 pa-0">
            TRANSACTION NUMBER:<span class="font-weight-bold">
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.pin_umber
                  ? this.transactionDetails.txn_data &&
                    this.transactionDetails.txn_data.pin_umber
                  : ""
              }}</span
            >
          </p>
          <p
            class="ma-0 pa-0"
            v-if="this.transactionDetails.txn_data.receiver_cpay_pinnumber"
          >
            Cash Pickup Pin Number:<span class="font-weight-bold">{{
              this.transactionDetails.txn_data.receiver_cpay_pinnumber
            }}</span>
          </p>
          <p>
            Transaction Date:
            {{
              this.transactionDetails.txn_data.txn_date
                ? this.transactionDetails.txn_data.txn_date
                : ""
            }}
          </p>
        </v-row>
        <v-row class="border_color ma-3">
          <v-col class="p-3 lh-2 main">
            <h6>REMITTER</h6>
            <v-divider class="ma-0"></v-divider>
            <div>
              <span class="w_200px">Name :</span>
              <b>{{
                senderInfo.middle_name
                  ? senderInfo.first_name +
                    " " +
                    senderInfo.middle_name +
                    " " +
                    senderInfo.last_name
                  : senderInfo.last_name
                  ? senderInfo.first_name + " " + senderInfo.last_name
                  : senderInfo.first_name
              }}</b>
            </div>
            <div>
              <span class="w_200px">Address :</span
              >{{ this.senderInfo.address ? this.senderInfo.address : "" }}
            </div>
            <div>
              <span class="w_200px">Customer Id :</span
              >{{ senderInfo.customer_id }}
            </div>
            <div>
              <span class="w_200px">Source of Fund:</span
              >{{
                senderInfo.source_of_funds && senderInfo.source_of_funds.value
                  ? senderInfo.source_of_funds.value
                  : ""
              }}
            </div>
            <div>
              <span class="w_200px">Purpose of Transaction:</span
              >{{
                transactionInfo.purpose_of_remittance &&
                transactionInfo.purpose_of_remittance.value
                  ? transactionInfo.purpose_of_remittance.value
                  : ""
              }}
            </div>
            <h6 class="mt-2">BENEFICIARY :</h6>
            <v-divider class="mt-0"></v-divider>
            <div>
              <span class="w_200px">Name :</span>
              <b>
                {{
                  recieverInfo.middle_name
                    ? recieverInfo.first_name +
                      " " +
                      recieverInfo.middle_name +
                      " " +
                      recieverInfo.last_name
                    : recieverInfo.last_name
                    ? recieverInfo.first_name + " " + recieverInfo.last_name
                    : recieverInfo.first_name
                }}</b
              >
            </div>
            <div>
              <span class="w_200px">Address :</span>
              {{ this.recieverInfo.address ? this.recieverInfo.address : "" }}
            </div>
            <div>
              <span class="w_200px">Telephone :</span>
              {{ this.recieverInfo.mobile ? this.recieverInfo.mobile : "" }}
            </div>
            <div>
              <span class="w_200px">Transaction Type :</span>
              <b>{{
                this.transactionDetails.txn_data.payment_mode
                  ? this.transactionDetails.txn_data.payment_mode
                  : ""
              }}</b>
            </div>
            <div>
              <span class="w_200px">Bank Name :</span>
              {{
                this.recieverInfo.location_name
                  ? this.recieverInfo.location_name
                  : ""
              }}
            </div>
            <div>
              <span class="w_200px">Account No :</span>
              {{
                this.recieverInfo.ac_number ? this.recieverInfo.ac_number : ""
              }}
            </div>
            <div>
              <span class="w_200px">THRU/Partner :</span
              ><span
                ><b>{{
                  this.transactionDetails.txn_data &&
                  this.transactionDetails.txn_data.payout_partner
                    ? this.transactionDetails.txn_data &&
                      this.transactionDetails.txn_data.payout_partner
                    : ""
                }}</b></span
              >
            </div>
          </v-col>
          <v-col class="bord-left">
            <v-simple-table>
              <tr>
                <td>Collected Amount</td>
                <td>
                  <span class="font-weight-bold">{{
                    transactionInfo.total_coll_amt
                      ? transactionInfo.total_coll_amt
                      : ""
                  }}</span>
                </td>
              </tr>
              <tr>
                <td class="">Service Charge</td>
                <td class="font-weight-bold">
                  {{
                    transactionInfo.service_charge
                      ? transactionInfo.service_charge
                      : ""
                  }}
                </td>
              </tr>

              <tr>
                <td>Transfer Amount</td>
                <td class="font-weight-bold">
                  {{
                    transactionInfo.transfer_amt
                      ? transactionInfo.transfer_amt
                      : ""
                  }}
                </td>
              </tr>
              <tr>
                <td>Exchange Rate</td>
                <td class="font-weight-bold">
                  1 {{ transactionInfo.coll_currency }} =
                  {{ transactionInfo.rate }}
                  {{ transactionInfo.pay_currency }}
                </td>
              </tr>
              <tr>
                <td>Payout Amount</td>
                <td class="font-weight-bold">
                  <span class="font-weight-bold text--primary">
                    {{
                      transactionInfo.payout_amt
                        ? transactionInfo.payout_amt
                        : ""
                    }}</span
                  >
                </td>
              </tr>
            </v-simple-table>
            <v-divider></v-divider>
            <v-row class="ma-0">
              <v-col>
                <div class="px-3 mb-2">Processed By:</div>
                {{
                  transactionInfo.created_by ? transactionInfo.created_by : ""
                }}
                <v-divider class="mt-3"></v-divider>
                <div class="px-3">Customer :</div>
                <v-divider class="mb-0 mt-3"></v-divider>
                <div class="px-3">Signature / Date</div>
              </v-col>
              <v-col>
                <b>Denomination</b>
                <v-simple-table class="w-100 border" dense>
                  <tbody>
                    <tr>
                      <td>500</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>200</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>100</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>50</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </html2Pdf>
  </section>
</template>

<script>
import PaymentService from "@/services/PaymentService/paymentService.js";
import html2Pdf from "@/utils/ExportPdf/vue-html-pdf.vue";
export default {
  name: "Transaction Report",
  data: () => {
    return {
      transactionDetails: {},
      isDownloadReciept: false,
      transactionInfo: null,
      senderInfo: null,
      recieverInfo: null,
      sender_fullname: "",
      receiver_fullname: "",
    };
  },
  components: {
    html2Pdf,
  },
  computed: {},
  watch: {},
  mounted() {
    if (this.$route.query.id) {
      this.getTxnDetailsbyID();
    }
  },
  methods: {
    handleDowloaded() {
      this.isDownloadReciept = false;
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },

    async getTxnDetailsbyID() {
      try {
        const responseData = await PaymentService.getTxnDetails(
          this.$route.query.id
        );
        if (responseData && responseData.data.status_code === 200) {
          console.log(responseData.data);
          this.transactionDetails = { ...responseData.data.data[0] };
          this.transactionInfo = this.transactionDetails.txn_data;
          this.senderInfo = this.transactionDetails.sender_data;
          this.recieverInfo = this.transactionDetails.receiver_data;
          // this.sender_fullname = this.senderInfo.first_name
          //   ? this.senderInfo.first_name
          //   : "" + " " + this.senderInfo.middle_name
          //   ? this.senderInfo.middle_name
          //   : "" + " " + this.senderInfo.last_name
          //   ? this.senderInfo.last_name
          //   : "";
          this.receiver_fullname = this.recieverInfo.full_name
            ? this.recieverInfo.full_name
            : "";
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTxnDetailsbyID();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

tr:nth-child(even) {
  background-color: $background-color;
}

// tr:hover {
//   background: none !important;
// }
th {
  text-transform: uppercase;
}

.main {
  line-height: 30px;
}

.bord-left {
  border-left: 1px solid rgb(197, 197, 197);
}
.border_color {
  border: 1px solid rgb(197, 197, 197);
}

th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
.w_200px {
  display: inline-block;
  width: 200px;
}
.pos_abs {
  position: absolute;
  top: 20%;
  font-size: 100px;
  font-weight: 600;
  left: 30%;
  z-index: 1;
  color: #ccc;
  opacity: 0.2;
  transform: rotate(-30deg);
}
.pos_abs_2 {
  position: absolute;
  top: 75%;
  font-size: 100px;
  font-weight: 600;
  left: 30%;
  z-index: 1;
  color: #ccc;
  opacity: 0.2;
  transform: rotate(-30deg);
}
</style>
